import { useSyncExternalStore } from 'react'

export type GuestDraftImportPrompt = Readonly<{
  organizationName?: string
  startImport: () => void
}>

const DISMISSED_KEY = 'buffer:publish:guest-draft-import-prompt:dismissed'

let currentPrompt: GuestDraftImportPrompt | null = null
const listeners = new Set<() => void>()

export function setGuestDraftImportPrompt(
  prompt: GuestDraftImportPrompt | null,
): void {
  if (prompt === currentPrompt) return
  currentPrompt = prompt
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function getPrompt(): GuestDraftImportPrompt | null {
  return currentPrompt
}

export function useGuestDraftImportPrompt(): GuestDraftImportPrompt | null {
  return useSyncExternalStore(subscribe, getPrompt, getPrompt)
}

export function isGuestDraftImportPromptDismissed(): boolean {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === 'true'
  } catch {
    return false
  }
}

export function dismissGuestDraftImportPrompt(): void {
  setGuestDraftImportPrompt(null)
  try {
    window.sessionStorage.setItem(DISMISSED_KEY, 'true')
  } catch {
    return
  }
}
